import React, { Component } from "react";
import Mensajes from "../../common/scripts/mensajes";
import PostulacionVacunaForm from "./postulacionVacunaForm";
import { isCallService } from "../../common/scripts/services";
import isAlphanumeric from "validator/es/lib/isAlphanumeric";
export default class EtapaPriorizacion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      nombres: "",
      apellidos: "",
      numeroDocumento: "",
      documentSelected: {
        CSDocumentoIdentidadText: "elija un documento",
      },
      ciudad: "",
      fechaNacimiento: "",

      showModal: false,
      isLoading: false,
      showPostulacionForm: false,
      showPostulacionFormModal: false,
      fechaNacimiento: "",
      showDescargaOption: false,
      visibleSelectorDocumento: false,
    };
    this.handleInput = this.handleInput.bind(this);
    this.handleModalMessage = this.handleModalMessage.bind(this);
    this.activateRegistraDatos = this.activateRegistraDatos.bind(this);
    this.activatePostulacionForm = this.activatePostulacionForm.bind(this);
    this.descargarCertificadoPriorizacion =
      this.descargarCertificadoPriorizacion.bind(this);
    this.getUserFecha = this.getUserFecha.bind(this);
    this.descargarCertificado = this.descargarCertificado.bind(this);
    this.submitListaCertficadoPriorizacion =
      this.submitListaCertficadoPriorizacion.bind(this);
    this.checkPostulacion = this.checkPostulacion.bind(this);
    this.fechaHandler = this.fechaHandler.bind(this);
  }

  submitListaCertficadoPriorizacion(
    nombreUsuario,
    numeroDocumnetoUsuario,
    fechaExpedicionCertificadoUsuario
  ) {
    let data = {
      Accion: "ADD",
      Lista: "TemasCovid19-CertificadosPostulacion",
      UrlSitio: document.location.origin + "/salud/transacciones",
      Campos: {
        Valores: [
          {
            NombreInternoCampo: "TipoDocumento",
            Valor: "CC",
          },
          {
            NombreInternoCampo: "NumeroDocumento",
            Valor: numeroDocumnetoUsuario,
          },
          {
            NombreInternoCampo: "FechaGeneracionCertificado",
            Valor: fechaExpedicionCertificadoUsuario,
          },
          {
            NombreInternoCampo: "DescargoCertificado",
            Valor: true,
          },
          {
            NombreInternoCampo: "NombreCompleto",
            Valor: nombreUsuario,
          },
        ],
      },
    };
    isCallService({
      // loadingElement: '',
      service: "UtilidadSharepoint",
      params: data,
      changeState: "submitCertificado",
      executeCallback: (result) => {},
      error: "error",
      condition: true,
      showLogs: false,
      mainObject: this,
    });
  }

  handleInput(event) {
    if (isAlphanumeric(event.target.value.trim())) {
      this.setState({ numeroDocumento: event.target.value.trim() });
      return;
    }
    if (event.target.value === "" && event.target.value.length === 0) {
      this.setState({ numeroDocumento: "" });
    }
  }

  descargarCertificado(
    nombreUsuario,
    numeroDocumentoUsuario,
    FechaExpedicionUsuario,
    isInList
  ) {
    let data = {
      Site: window.location.origin + "/salud/transacciones/",
      TemplateUrl:
        window.location.origin +
        "/salud/transacciones/PlantillasDocWord/TemplateCertificadoPriorizacion.docx",
      OutputFormat: ".pdf",
      DocumentName: "Certificado de Priorización",
      TemplateBookmarks: [
        {
          Key: "NOMBRE",
          Value: nombreUsuario,
        },
        {
          Key: "NUMERO_DOCUMENTO",
          Value: numeroDocumentoUsuario,
        },
        {
          Key: "FECHA_EXPEDICION",
          Value: FechaExpedicionUsuario,
        },
        {
          Key: "TIPO_DOCUMENTO",
          Value: this.state.documentSelected.CSDocumentoIdentidadText,
        },
      ],
    };

    isCallService({
      // loadingElement: '',
      loadingElement: ".mainLayout_etapa_priorizacion",
      service: "CreateDocument",
      params: data,
      changeState: "fileCertificadoDescargaBase64",
      executeCallback: (result) => {
        const isIE =
          window.navigator.userAgent.includes("Trident/7.0") ||
          window.navigator.userAgent.includes("Edge");
        if (!isIE) {
          const file = document.createElement("a");
          file.href = "data:application/pdf;base64," + result.Base64;
          file.download = result.DocumentName;
          document.body.appendChild(file);
          file.click();
          document.body.removeChild(file);
        } else {
          const binary = atob(result.Base64.replace(/\s/g, ""));
          const buffer = new ArrayBuffer(binary.length);
          const view = new Uint8Array(buffer);
          for (let i = 0; i < binary.length; i++) {
            view[i] = binary.charCodeAt(i);
          }
          const blob = new Blob([view], { type: "application/pdf;base64" });
          navigator.msSaveBlob(blob, result.Base64);
        }

        //despues guardarlo en la list sharepoint

        //this.cleanForm();//limpiar todos los estados
        this.setState({ showModal: false });
        if (isInList === false) {
          //lo guarda en la lista
          this.submitListaCertficadoPriorizacion(
            nombreUsuario,
            numeroDocumentoUsuario,
            FechaExpedicionUsuario
          );
        }
      },
      error: "error",
      condition: true,
      showLogs: false,
      mainObject: this,
    });
  }

  checkPostulacion() {
    let data = {
      Accion: "GET",
      Lista: "TemasCovid19-CertificadosPostulacion",
      UrlSitio: document.location.origin + "/salud/transacciones",
      Vista: ["DescargoCertificado", "FechaGeneracionCertificado"],
      Campos: {
        Query: [
          {
            NombreInternoCampo: "NumeroDocumento",
            Valor: this.state.numeroDocumento,
            Tipo: "Text",
          },
        ],
      },
    };
    isCallService({
      // loadingElement: '',
      loadingElement: ".mainLayout_etapa_priorizacion",
      service: "UtilidadSharepointGet",
      params: data,
      changeState: "estaPostuladoList",
      executeCallback: (result) => {
        const { Resultado } = result;
        if (Array.isArray(Resultado) && Resultado.length === 0) {
          //osea no esta postulado, usamos la fecha del generada actual
          //creamos el documento y lo subimos  a  la lista.
          this.descargarCertificado(
            this.state.NombreUsuarioConsultado,
            this.state.numeroDocumento,
            moment().format("DD-MM-YYYY hh:mm A"),
            false
          );
        }
        if (Array.isArray(Resultado) && Resultado.length > 0) {
          //asumiendo que no hay duplicados y solo un registro
          //usamos la fecha
          const { Valores = null } = Resultado[0];
          const fechaExpedicionCertificadoLista = Valores.filter(
            (el) => el.NombreInternoCampo === "FechaGeneracionCertificado"
          );
          this.descargarCertificado(
            this.state.NombreUsuarioConsultado,
            this.state.numeroDocumento,
            fechaExpedicionCertificadoLista[0].Valor,
            true
          );
        }
      },
      error: "error",
      condition: true,
      showLogs: false,
      mainObject: this,
    });
  }

  getUserFecha() {
    isCallService({
      // loadingElement: '',
      loadingElement: ".mainLayout_etapa_priorizacion",
      service: "ObtenerRiesgosUsuario",
      params: {
        TipoDocumento: this.state.documentSelected.CSIdDocumentoText,
        NumeroDocumento: this.state.numeroDocumento,
        TiempoCache: 120,
      },
      changeState: "infoUser",
      executeErrorCallback: () => {
        this.setState({
          fechaNacimiento: "",
          NombreUsuarioConsultado: "",
          numeroDocumento: "",
          isLoading: false,
          documentSelected: {
            CSDocumentoIdentidadText: "elija un documento",
          },
        });
      },
      executeCallback: (result) => {
        const { FechaNacimiento = "", Nombre = "" } = result;
        const formatServiceDate = moment(FechaNacimiento, "DD/MM/YYYY").format(
          "YYYY-MM-DD"
        );

        if (formatServiceDate === this.state.fechaNacimiento) {
          //mostar el modal con el icono descarga
          this.setState({
            isLoading: false,
            priorizado: true,
            showModal: true,
            showDescargaOption: true,
            NombreUsuarioConsultado: Nombre,
            modalText: i18next.t("modales.priorizacionSi"),
            modalIcon: `fa fa-check-circle`,
            iconColor: ` green`,
          });
        } else {
          //mostrar el modal sin el icono de descarga

          this.setState({
            isLoading: false,
            priorizado: true,
            showModal: true,
            showDescargaOption: false,
            NombreUsuarioConsultado: "",
            modalText: i18next.t("modales.priorizacionSi"),
            modalIcon: `fa fa-check-circle`,
            iconColor: ` green`,
          });
        }
        compensar.quitarLoading(".mainLayout_etapa_priorizacion");
      },
      error: "error",
      condition: true,
      showLogs: false,
      mainObject: this,
    });
  }
  getUserData() {
    compensar.quitarLoading(".mainLayout_etapa_priorizacion");
    this.setState({ isLoading: true }, async () => {
      compensar.mostrarLoading(".mainLayout_etapa_priorizacion");
      try {
        const data = await fetch(
          "https://prod-160.westus.logic.azure.com:443/workflows/77983881670d412684c95f0fafd3a3d4/triggers/manual/paths/invoke?api-version=2016-06-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=_3Hko8H8fTboTFVoDMd__TKfHpk3dHGgcHDuXLLPiTk",
          {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              TipoDocumento: this.state.documentSelected.CSSiglaText,
              Documento: this.state.numeroDocumento,
            }),
          }
        );
        const response = await data.json();
        const msgInResponse = "msg" in response;
        if (
          msgInResponse === false //si existe el usuario
        ) {
          //call GetuserFecha Service
          this.getUserFecha();
        } else if (msgInResponse === true) {
          //no existe usuario

          this.setState({
            isLoading: false,
            priorizado: false,
            showModal: true,
            showDescargaOption: false,
            NombreUsuarioConsultado: "",
            modalText: i18next.t("modales.priorizacionNo"),
            modalIcon: `fa fa-times-circle`,
            iconColor: ` red`,
          });
          compensar.quitarLoading(".mainLayout_etapa_priorizacion");
        }
      } catch (error) {
        compensar.quitarLoading(".mainLayout_etapa_priorizacion");
        this.setState({ fechaNacimiento: null, NombreUsuarioConsultado: "" });
      }
    });
  }

  handleModalMessage() {
    return { __html: this.state.modalText };
  }
  activateRegistraDatos() {
    compensar.quitarLoading(".mainLayout_etapa_priorizacion");
    let documentSelected = { CSDocumentoIdentidadText: "elija un documento" };
    this.props.activateRegistraDatos();
    this.setState({ showModal: false, documentSelected, numeroDocumento: "" });
  }

  activatePostulacionForm() {
    this.setState({ showModal: false, showPostulacionForm: true });
  }

  handleSubmitPostulacion(data) {
    isCallService({
      loadingElement: ".mainLayout_etapa_priorizacion",
      service: "UtilidadSharepoint",
      params: data,
      changeState: "resultFromPostulacionForm",
      executeCallback: (result) => {
        this.setState({
          showPostulacionForm: false,
          showPostulacionFormModal: true,
          modalIcon: `fa fa-check-circle`,
          iconColor: ` green`,
          modalText: i18next.t("modales.postulacionVacunaFormModal"),
        });
      },
      error: "error",
      condition: true,
      showLogs: false,
      mainObject: this,
    });
  }
  descargarCertificadoPriorizacion() {
    this.checkPostulacion();
    compensar.quitarLoading(".mainLayout_etapa_priorizacion");
  }
  fechaHandler(event) {
    this.setState({ fechaNacimiento: event.target.value });
  }
  render() {
    let props = this.props;
    let [idNum, idList, selectedDoc] = [
      this.state.numeroDocumento,
      props.documentos,
      this.state.documentSelected.CSDocumentoIdentidadText,
    ];
    return (
      <section>
        <div
          dangerouslySetInnerHTML={props.handleGenericHtml(
            i18next.t("forms.formEtapaPriorizacion")
          )}
        />

        <Mensajes
          showModal={this.state.showModal}
          closeModal={() => {
            compensar.quitarLoading(".mainLayout_etapa_priorizacion");
            this.setState({ showModal: false });
          }}
          MessageTitle={i18next.t("modales.tituloError")}
          Icono={this.state.modalIcon}
          colorIco={this.state.iconColor}
          msg={
            <div
              style={{ whiteSpace: "pre-line" }}
              dangerouslySetInnerHTML={this.handleModalMessage()}
            />
          }
          MainButtonAction={() =>
            this.state.priorizado == true
              ? this.activateRegistraDatos()
              : this.activatePostulacionForm()
          }
          MainButtonText={
            this.state.priorizado == true
              ? i18next.t("modales.botonActualizaDatos")
              : i18next.t("modales.botonPostulacion")
          }
          DescargarButtonAction={() =>
            this.state.priorizado === true
              ? this.descargarCertificadoPriorizacion()
              : null
          }
          showDescargaOption={this.state.showDescargaOption}
          DescargarButtonText={
            this.state.priorizado === true
              ? i18next.t("modales.DescargaMensajes")
              : null
          }
          AltButtonAction={() => {
            compensar.quitarLoading(".mainLayout_etapa_priorizacion");
            this.setState({ showModal: false });
          }}
          AltButtonText={i18next.t("modales.buttonAceptar")}
        />

        <Mensajes
          showModal={this.state.showPostulacionFormModal}
          closeModal={() => {
            compensar.quitarLoading(".mainLayout_etapa_priorizacion");
            this.setState({ showPostulacionFormModal: false });
          }}
          MessageTitle={i18next.t("modales.tituloError")}
          Icono={this.state.modalIcon}
          colorIco={this.state.iconColor}
          msg={
            <div
              style={{ whiteSpace: "pre-line" }}
              dangerouslySetInnerHTML={this.handleModalMessage()}
            />
          }
          AltButtonAction={() => {
            compensar.quitarLoading(".mainLayout_etapa_priorizacion");
            this.setState({ showPostulacionFormModal: false });
          }}
          AltButtonText={i18next.t("modales.buttonAceptar")}
        />

        <form
          className="formularioSolicitud noPadding"
          onSubmit={(e) => e.preventDefault()}
        >
          <div className="form-group row">
            <div className="col-sm-4">
              <p className="col-form-label formularioSolicitud--text-aligned formularioSolicitud--label">
                Documento de identidad*
              </p>
              <p className="formularioSolicitud--text-aligned">
                {i18next.t("forms.cedulaIndicacion")}
              </p>
            </div>

            <div className="col-sm-3">
              <button
                disabled={false}
                className="dropdown-toggle formularioSolicitud--dropDown"
                //type="button"
                id="dropdownCedula"
                style={{ cursor: "pointer" }}
                //data-toggle="dropdown"
                onClick={() =>
                  this.setState({
                    visibleSelectorDocumento:
                      !this.state.visibleSelectorDocumento,
                  })
                }
              >
                <div>
                  <p className="text-left">
                    {this.state.documentSelected.CSDocumentoIdentidadText}
                  </p>
                </div>
                <span className="caret"></span>
                <ul
                  className={`dropdown-menu`}
                  style={{
                    cursor: "pointer",
                    display: `${
                      this.state.visibleSelectorDocumento ? "block " : "none"
                    }`,
                  }}
                  aria-labelledby="dropdownCedula"
                >
                  {idList?.map((item, index) => {
                    return (
                      <li
                        key={index}
                        onClick={() =>
                          this.setState({
                            documentSelected: item,
                            visibleSelectorDocumento: false,
                          })
                        }
                      >
                        <p>{item.CSDocumentoIdentidadText}</p>
                      </li>
                    );
                  })}
                </ul>
              </button>
            </div>

            <div className="col-sm-5">
              <input
                disabled={
                  this.state.documentSelected.CSDocumentoIdentidadText ===
                  "elija un documento"
                }
                type="text"
                className={
                  this.state.numeroDocumento == "" ||
                  this.state.numeroDocumento == " "
                    ? "form-control formularioSolicitud--input formularioSolicitud--input-error "
                    : "form-control formularioSolicitud--input"
                }
                value={this.state.numeroDocumento}
                onChange={this.handleInput}
                // onBlur={() => props.handleBlur(event)}
                name="NumeroDocumento"
                maxLength={33}
              />
              {this.state.numeroDocumento == "" ||
              this.state.numeroDocumento == " " ||
              this.state.numeroDocumento == null ? (
                <p className="formularioSolicitud--input-errorLabel">
                  {i18next.t("forms.cedulaError")}
                </p>
              ) : null}
            </div>
          </div>
          <div className="form-group row">
            <label className="col-sm-4 col-form-label formularioSolicitud--text-aligned">
              {i18next.t("forms.fechaNacimiento")}
            </label>
            <div className="col-sm-8">
              <input
                type="date"
                className={
                  this.state.fechaNacimiento == "" ||
                  this.state.fechaNacimiento == " "
                    ? "formularioSolicitud--date formularioSolicitud--dropDown formularioSolicitud--input formularioSolicitud--input-error"
                    : "formularioSolicitud--date formularioSolicitud--dropDown formularioSolicitud--input"
                }
                value={this.state.fechaNacimiento}
                onChange={this.fechaHandler}
                // onFocus={() => props.handleInput(event)}
                name="FechaNacimiento"
              />
              {this.state.fechaNacimiento == "" ||
              this.state.fechaNacimiento == " " ||
              this.state.fechaNacimiento == null ? (
                <p className="formularioSolicitud--input-errorLabel">
                  {i18next.t("forms.errorFechaNacimiento")}
                </p>
              ) : null}
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12 text-center">
              <button
                type="button"
                className="btn btn-default"
                onClick={() => this.getUserData()}
                disabled={
                  idNum == "" ||
                  idNum == " " ||
                  idNum == null ||
                  selectedDoc == "elija un documento" ||
                  this.state.fechaNacimiento == "" ||
                  this.state.fechaNacimiento == " " ||
                  this.state.fechaNacimiento == null ||
                  this.state.isLoading == true
                    ? true
                    : false
                }
              >
                {this.state.isLoading == true
                  ? "Consultando..."
                  : i18next.t("forms.buttonPriorizacion")}
              </button>
            </div>
          </div>
        </form>

        {this.state.showPostulacionForm ? (
          <PostulacionVacunaForm
            idList={props.documentos}
            handleSubmit={this.handleSubmitPostulacion.bind(this)}
          />
        ) : null}
      </section>
    );
  }
}
